import { FetchPublicMetaDataRequestTypes } from '../actions/PublicMetaDataActions';
import { makeRequestStatusSelector } from './RequestStatusSelectors';
export const fetchPublicMetaDataStatus = makeRequestStatusSelector(FetchPublicMetaDataRequestTypes.REQUEST);